import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { Auth } from 'aws-amplify';
import IdleTimer from 'react-idle-timer';

import config from 'config';
import Routes from 'routes';

import { getAuthenticatedUserGroups } from 'actions';
import 'App.scss';

class App extends Component {
	constructor(props) {
		super(props);

		this.idleTimer = null;

		this.state = {
			isAuthenticated: false,
			isAuthenticating: true,
			authGroups: []
		};
	}

	onIdle() {
		this.setState({
			isAuthenticated: false,
			isAuthenticating: false,
			authGroups: []
		});
	}

	async componentDidMount() {
		try {
			const { idToken } = await Auth.currentSession();
			if (idToken) {
				const { authenticatedUserGroups: authGroups } =
					await getAuthenticatedUserGroups();
				this.userHasAuthenticated(true, authGroups);
			}
		} catch (e) {
			if (e !== 'No current user') {
				console.error('Unexpected error in App:componentDidMount', e);
			}
		}

		this.setState({
			isAuthenticating: false
		});
	}

	userHasAuthenticated = (isAuthenticated, authGroups) => {
		this.setState({
			isAuthenticated,
			authGroups
		});
	};

	render() {
		const childProps = {
			isAuthenticated: this.state.isAuthenticated,
			userHasAuthenticated: this.userHasAuthenticated,
			authGroups: this.state.authGroups
		};

		return (
			!this.state.isAuthenticating && (
				<IdleTimer
					ref={(ref) => {
						this.idleTimer = ref;
					}}
					element={document}
					onIdle={this.onIdle.bind(this)}
					timeout={config.idleTimeout}
				>
					<Routes childProps={childProps} />
				</IdleTimer>
			)
		);
	}
}

// dispatch is used as a callback which gets invoked once some async action is complete
// dispatch is simply a function which dispatches an action to the Redux store after,
// let's say, you fetch data from an API (which is asynchronous)
const mapDispatchToProps = (dispatch) => ({});

export default withRouter(connect(null, mapDispatchToProps)(App));
